import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireStaff, SessionProvider } from './auth/session';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { AuthCallback } from './pages/AuthCallback';
import { Dashboard } from './pages/Dashboard';
import { UsersList } from './pages/users/UsersList';
import { UserNew } from './pages/users/UserNew';
import { UserDetail } from './pages/users/UserDetail';
import { OrgsList } from './pages/orgs/OrgsList';
import { OrgNew } from './pages/orgs/OrgNew';
import { OrgDetail } from './pages/orgs/OrgDetail';
import { OffersList } from './pages/offers/OffersList';
import { OfferNew } from './pages/offers/OfferNew';
import { OfferDetail } from './pages/offers/OfferDetail';
import { PacksList } from './pages/offers/PacksList';
import { Prices } from './pages/prices/Prices';
import { OrdersList } from './pages/orders/OrdersList';
import { VatReviews } from './pages/vat/VatReviews';
import { MonthlyBilling } from './pages/billing/MonthlyBilling';
import { InvoicesList } from './pages/invoices/InvoicesList';
import { InvoiceForm } from './pages/invoices/InvoiceForm';
import { MailList } from './pages/mail/MailList';
import { WaitlistList } from './pages/waitlist/WaitlistList';
import { ContactRequestsList } from './pages/contact/ContactRequestsList';
import { ContactRequestDetail } from './pages/contact/ContactRequestDetail';
import { CreditsOverview } from './pages/credits/CreditsOverview';
import { MailDetail } from './pages/mail/MailDetail';
import { AuditList } from './pages/audit/AuditList';
import { Insights } from './pages/quality/Insights';
import { ConversationsList } from './pages/quality/ConversationsList';
import { SandboxDetail } from './pages/sandboxes/SandboxDetail';
import { SandboxesList } from './pages/sandboxes/SandboxesList';
import { ConversationDetail } from './pages/quality/ConversationDetail';
import { IssuesList } from './pages/issues/IssuesList';
import { IssueDetail } from './pages/issues/IssueDetail';

export default function App() {
  return (
    <SessionProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          element={
            <RequireStaff>
              <Layout />
            </RequireStaff>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/new" element={<UserNew />} />
          <Route path="/users/:id" element={<UserDetail />} />
          <Route path="/organizations" element={<OrgsList />} />
          <Route path="/organizations/new" element={<OrgNew />} />
          <Route path="/organizations/:id" element={<OrgDetail />} />
          <Route path="/offers" element={<OffersList />} />
          <Route path="/offers/new" element={<OfferNew />} />
          <Route path="/offers/:id" element={<OfferDetail />} />
          <Route path="/packs" element={<PacksList />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/orders" element={<OrdersList />} />
          <Route path="/vat" element={<VatReviews />} />
          <Route path="/monthly" element={<MonthlyBilling />} />
          <Route path="/invoices" element={<InvoicesList />} />
          <Route path="/invoices/new" element={<InvoiceForm mode="new" />} />
          <Route path="/invoices/:id" element={<InvoiceForm mode="edit" />} />
          <Route path="/waitlist" element={<WaitlistList />} />
          <Route path="/contact-requests" element={<ContactRequestsList />} />
          <Route path="/contact-requests/:id" element={<ContactRequestDetail />} />
          <Route path="/credits" element={<CreditsOverview />} />
          <Route path="/mail" element={<MailList />} />
          <Route path="/mail/:id" element={<MailDetail />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/conversations" element={<ConversationsList />} />
          <Route path="/conversations/:id" element={<ConversationDetail />} />
          <Route path="/sandboxes" element={<SandboxesList />} />
          <Route path="/sandboxes/:id" element={<SandboxDetail />} />
          <Route path="/issues" element={<IssuesList />} />
          <Route path="/issues/:id" element={<IssueDetail />} />
          <Route path="/audit" element={<AuditList />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SessionProvider>
  );
}
